<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-title1">B<span class="small">LACKSTONE</span></p>
<p class="chap-title2">(S<span class="small">EE</span> W<span class="small">OONSOCKET</span>)</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter1.vue?814952aa